import { clearObject } from './clearObject';

export const getAverageTimeFromSeconds = seconds => {
  if (!seconds) return null;

  const month = Math.floor(seconds / (3600 * 24 * 30));
  const day = Math.floor((seconds % (3600 * 24 * 30)) / (3600 * 24));
  const hour = Math.floor(((seconds % (3600 * 24 * 30)) % (3600 * 24)) / 3600);
  const minute = Math.floor((((seconds % (3600 * 24 * 30)) % (3600 * 24)) % 3600) / 60);

  // give a name for this function => const name = value => value > 1;
  const isPlural = value => value > 1;

  const timeObject = { month, day, hour, minute };
  const cleanTimeObject = clearObject(timeObject, [null, undefined, '', 0]);

  if (Object.keys(cleanTimeObject).length === 0) return null;

  const labels = {
    day: 'day',
    minute: 'min',
    hour: 'hr'
  };

  const result = Object.entries(cleanTimeObject).reduce((prev, cur, index) => {
    const [key, value] = cur;

    const label = isPlural(value) ? `${labels[key]}s` : labels[key];
    return `${prev} ${value} ${label}${
      index === Object.entries(cleanTimeObject).length - 1 ? '' : ','
    }`;
  }, '');

  return result;
};
